import { createContext } from 'react';
import type { DeepNonNullable } from 'ts-essentials';

import type { ContentService } from '@src/services/content/content.service';

export type CmsContent = DeepNonNullable<Awaited<ReturnType<ContentService['getCommonContent']>>>;

export const CmsContentContext = createContext<CmsContent | undefined>(undefined);
export const CmsContentProvider = CmsContentContext.Provider;
